import { Tooltip as AntdTooltip, type TooltipProps as AntdTooltipProps } from 'antd'

export type TooltipProps = AntdTooltipProps

export function Tooltip(props: TooltipProps) {
  return <AntdTooltip {...props} />
}
